import * as Constants from '../../constants';

export const cv = {
    get links(): ReturnType<typeof Constants.getCVLinks> {
        return Constants.getCVLinks(this);
    },
    path: 'cv',
    PDFTitle: 'Ściągnij PDF',
    PDFPrefix: Constants.CV_PDFPrefix,
    general: `Jestem księgową z ponad 10-letnim doświadczeniem w obszarze rachunkowości i podatków, zdobytym w Polsce i na Białorusi. Obecnie pracuję w biurze rachunkowym w Polsce, gdzie aktywnie uczestniczę w prowadzeniu księgowości klientów – zajmuję się m.in. księgowaniem dokumentów, rozliczeniami krajowymi i zagranicznymi, ewidencją kosztów oraz przygotowywaniem zestawień finansowych. Moje wcześniejsze doświadczenie w administracji skarbowej pozwala mi na głębsze zrozumienie przepisów podatkowych i ich praktyczne zastosowanie. Systematycznie rozwijam swoje kompetencje poprzez kursy i szkolenia w Stowarzyszeniu Księgowych w Polsce. Jestem osobą rzetelną, samodzielną i zaangażowaną, gotową do dalszego rozwoju i podejmowania nowych wyzwań zawodowych.`,
    consent: `Wyrażam zgodę na przetwarzanie moich danych osobowych w celu prowadzenia rekrutacji na aplikowane przeze mnie stanowisko.`,

    skills: {
        title: 'UMIEJĘTNOŚCI',
        all: [
            `znajomość programów księgowych: Enova365, Saldeo, Optima, Kamsoft`,
            `znajomość MS Office`,
            `znajomość ustawy o rachunkowości`,
            `znajomość przepisów podatkowych`,
            `świetna organizacja pracy`,
            `skrupulatność i odpowiedzialność`,
            `umiejętności komunikacyjne`,
            `umiejętność pracy w zespole`,
        ],
    },
    languages: {
        title: 'JĘZYKI',
        all: [
            { language: 'Język polski:', level: Constants.levelPL },
            { language: 'Język angielski:', level: Constants.levelENG },
            { language: 'Język rosyjski:', level: 'doskonały' },
        ],
    },
    university: {
        title: 'WYKSZTAŁCENIE',
        all: [
            {
                years: `2004 - 2009`,
                nameUniversity: `Homelski Uniwersytet Państwowy im. Franciszka Skaryny`,
                url: `https://www.gsu.by/`,
                specialityTitle: 'kierunek',
                speciality: `ekonomia, działalność handlowa`,
            },
        ],
    },
    courses: {
        title: 'DODATKOWE KURSY',
        all: [
            {
                years: `2025 - 2026`,
                nameUniversity: `Stowarzyszenie księgowych w Polsce`,
                url: `https://skwp.pl/`,
                specialityTitle: 'kierunek',
                speciality: `Główny księgowy`,
                certPath: Constants.certPL_3,
            },
            {
                years: `2024 - 2025`,
                nameUniversity: `Stowarzyszenie księgowych w Polsce`,
                url: `https://skwp.pl/`,
                specialityTitle: 'kierunek',
                speciality: `Specjalista ds. rachunkowości (samodzielna księgowa)`,
                certPath: Constants.certPL_2,
            },
            {
                years: `2023 - 2024`,
                nameUniversity: `Stowarzyszenie księgowych w Polsce`,
                url: `https://skwp.pl/`,
                specialityTitle: 'kierunek',
                speciality: `Księgowa (pełna księgowość)`,
                certPath: Constants.certPL_1,
            },
            {
                years: `2024 - 2026`,
                nameUniversity: `Szkoła policealna Cosinus`,
                url: `https://www.cosinus.pl/`,
                specialityTitle: 'kierunek',
                speciality: `Administracja`,
                certPath: Constants.certPL_0,
            },
        ],
    },
    experience: {
        title: 'DOŚWIADCZENIE ZAWODOWE',
        all: [
            {
                year: `styczeń 2026 - obecnie`,
                place: `Ergotax sp. z o.o., biuro rachunkowe, Polska`,
                profession: `Księgowa`,
                experiences: [
                    `Prowadzenie pełnego cyklu księgowego - od weryfikacji i dekretacji dokumentów do uzgodnienia kont i przygotowania danych do zamknięcia miesiąca.`,
                    `Księgowanie dokumentw dotyczących przychodów, kosztów, środków trwałych, importu usług, WNT.`,
                    `Kontrola poprawności i kompletności dokumentacji księgowej.`,
                    `Uzgadnianie kont księgowych oraz analiza sald i zapisów księgowych.`,
                    `Przygotowanie danych i zestawień na potrzeby rozliczeń podatkowych i zamknięcia miesiąca.`,
                    `Przygotowywanie sprawozdań do GUS.`,
                ],
            },
            {
                year: `październik 2024 - marzec 2026`,
                place: `Jadmar sp. z o.o., biuro rachunkowe, Polska`,
                profession: `Księgowa`,
                experiences: [
                    `Księgowanie dokumentów księgowych w pełnej księgowości.`,
                    `Księgowanie wyciągów bankowych i raportów kasowych.`,
                    `Ewidencja kosztów, przychodów oraz rozliczeń międzyokresowych.`,
                    `Uzgadnianie rozrachunków z kontrahentami.`,
                    `Wykonywanie czynności związanych z zamknięciem miesiąca.`,
                    `Wyliczanie podatków VAT, CIT.`,
                    `Przygotowanie deklaracji podatkowych VAT.`,
                    `Przygotowywanie sprawozdań do GUS.`,
                ],
            },
            {
                year: `2017 - 2021; 2023 - 2024`,
                place: `FotoCeramika sp. z o.o., Białoruś`,
                profession: `Samodzielna księgowa`,
                experiences: [
                    `Prowadzenie ewidencji księgowych, księgowanie przychodów, kosztów, operacji bankowych i kasowych.`,
                    `Kontrola rozrachunków z dostawcami i odbiorcami.`,
                    `Dokonywanie płatności, prowadzenie rachunków bieżących organizacji.`,
                    `Sporządzanie sprawozdań finansowych, GUS oraz rozliczeń podatkowych.`,
                    `Współpraca z instytucjami zewnętrznymi (urząd skarbowy, ZUS, inne).`,
                ],
            },
            {
                year: `2009 - 2017; 2021 - 2022`,
                place: `Urząd skarbowy, departament kontroli nad osobami prawnymi, Białoruś`,
                profession: `Inspektor podatkowy`,
                experiences: [
                    `Przeprowadzanie kontroli podatkowych osób prawnych.`,
                    `Weryfikacja prawidłowości dokumentacji rachunkowej i rozliczeń podatkowych.`,
                    `Kontrola rozliczeń VAT, CIT, PIT oraz kosztów uzyskania przychodów.`,
                ],
            },
        ],
    },
    interests: {
        title: 'ZAINTERESOWANIA',
        all: [`Siłownia`, `czytanie`, `zdrowy tryb życia`, `rozwój cech osobistych i zawodowych`],
    },
};
